import { IActivatable, ISharedContext } from "../support/registration_form_component"
import { AdminEditableText } from "../support/form_helpers"

export function RegistrationThankYou(props: IActivatable & ISharedContext) {
  if (!props.active) {
    return <div />
  }

  const client = props.client
  // const clientLongName = client.long_name
  const short_id = props.short_id
  const printUrl = `${props.urls.print}&token=${short_id || ""}`
  const urls = props.urls

  return (
    <div className="step padding--top cold-start cold-start--lg" style={{ padding: "0 50px" }} id="thank-you">
      <div className="big-icon">
        <i className="fa fa-check-circle"/>
      </div>
      <h1>Thank you!</h1>
      <div style={{ marginBottom: "40px" }}>
        <AdminEditableText
          text={client.thank_you_text}
          url={urls.admin_edit_thank_you_text}
          canEdit={props.canEditText}
        />
      </div>
      <a href={printUrl} className="btn btn-info btn-lg" data-turbolinks="false">
          Print a Copy of Your Information
      </a>
    </div>
  )
}
